module.exports = __webpack_public_path__ + "img/shopify.cb1529de.svg";